<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>管理</el-breadcrumb-item>
      <el-breadcrumb-item>平台充值账户管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区域 -->
    <el-card>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" class="demo-ruleForm">
        <el-form-item label="平台账户类型" prop="type">
          <el-input v-model="ruleForm.type"></el-input>
        </el-form-item>
        <el-form-item label="账户名称" prop="name">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="平台账户" prop="account">
          <el-input v-model="ruleForm.account"></el-input>
        </el-form-item>
      </el-form>
      <el-button type="primary" plain @click="sureClick" v-if="canLook == 1">确认修改</el-button>
    </el-card>
  </div>
</template>

<script>

export default {
  data () {
    return {
      canLook: 1,
      ruleForm: {
        type: 0,
        name: 0,
        account: 0,
      },
      rules: {
        type: [
          { required: true, message: '平台账户类型不能为空', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '账户名称不能为空', trigger: 'blur' }
        ],
        account: [
          { required: true, message: '平台账户不能为空', trigger: 'blur' }
        ],
      },
    }
  },

  created () {
    this.getDetail();
  },

  methods: {

    // 编辑
    editOrder (id) {
      console.log(id);
      // this.$router.push({ path: '/order/detail', query: { id: id } })
    },

    //修改订单信息
    sureClick () {
      this.$refs.ruleForm.validate(async valid => {
        if (!valid) return
        const { data: res } = await this.$http.post('admin/changePlatformAccount', this.ruleForm)
        if (res.code !== 200) {
          return this.$message.error('修改信息失败！')
        }
        this.$message.success('修改信息成功！')
        this.getDetail();
      })
    },

    async getDetail () {
      const { data: res } = await this.$http.get('admin/getPlatformAccount')
      if (res.code !== 200) {
        return this.$message.error('获取信息失败！')
      }
      console.log(res)
      this.ruleForm = res.result
      if (window.sessionStorage.getItem('pathCanLook') == 2) { //仅查看
        this.canLook = 2
      }
    },
  }
}
</script>

<style lang="less" scoped>
.el-button {
  margin-top: 30px;
}
</style>
